import type { LabeledStat } from '@/components/common/StatCardGrid';

interface HandOutRow {
  distributedQty: number;
}

interface InstituteHandOutRow extends HandOutRow {
  instituteId: number | null;
}

function sumDistributedQty(rows: readonly HandOutRow[]): number {
  return rows.reduce((total, row) => total + row.distributedQty, 0);
}

function countInstitutes(entries: readonly InstituteHandOutRow[]): number {
  return new Set(entries.map((entry) => entry.instituteId).filter((id) => id !== null)).size;
}

function getDistributedStatCard(rows: readonly HandOutRow[] | undefined): LabeledStat {
  return {
    key: 'distributed',
    label: 'Distributed',
    value: rows === undefined ? undefined : sumDistributedQty(rows),
  };
}

export function getZmHandOutStatCards(zms: readonly HandOutRow[] | undefined): LabeledStat[] {
  return [{ key: 'zms', label: 'ZMs', value: zms?.length }, getDistributedStatCard(zms)];
}

export function getInstituteHandOutStatCards(
  entries: readonly InstituteHandOutRow[] | undefined,
): LabeledStat[] {
  return [
    { key: 'entries', label: 'Entries', value: entries?.length },
    {
      key: 'institutes',
      label: 'Institutes',
      value: entries === undefined ? undefined : countInstitutes(entries),
    },
    getDistributedStatCard(entries),
  ];
}
